// eslint-disable-next-line @typescript-eslint/no-explicit-any
import {Func} from "@/utilities/type-helpers";
import {watch} from "@vue/composition-api";
import XRegExp from "xregexp";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function r2a<T>(record?: Record<any, T>): Array<T> | undefined {
    return record ? Object.keys(record).map(key => record[key]) : record;
}

export function getExtension(str: string) {
	return str?.slice((str.lastIndexOf('.') - 1 >>> 0) + 2);
}

export function getNumberEnumKeyValue(e: Record<string | number, string | number>) {
	return (Array.from(Object.entries(e)).filter(e => Number.isNaN(-e[0])).map(e => ({k: e[0], v: e[1]})));
}

export async function waitFor<T>(func: Func<T>) {
	await new Promise(resolve => {

		if (func()) {

			resolve();

			return;
		}

		const loadWatch = watch(func, () => {

			if (func()){

				loadWatch();

				resolve();
			}
		});
	});
}

export async function waitForMilliseconds(milliseconds: number) {

	await new Promise(resolve => setTimeout(resolve, milliseconds));
}

export function generateMatches(text: string) {

	if (!text || text.trim() === '') return [];

	return text.split(' ').filter(split => split.trim() !== '' && split.length >= 1).map(split => XRegExp(XRegExp.escape(split), 'gi')).sort(match => match.source.length);
}